// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"584":"f09c7d68","670":"f09c7d68","837":"f09c7d68"}[chunkId] + ".css";
};